import { Component } from '@angular/core';
import { DynamicContentfulGrid } from 'src/app/@enums/dynamicContentfulComponents';
import { DynamicGridComponent } from '../../contentful/dynamic-grid/dynamic-grid.component';
import { TranslatePipe, UrlModule } from 'haba-core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-checkout-login-register-form',
  templateUrl: './checkout-login-register-form.component.html',
  styleUrls: ['./checkout-login-register-form.component.scss'],
  imports: [DynamicGridComponent, TranslatePipe, RouterModule, UrlModule],
})
export class CheckoutLoginRegisterFormComponent {
  DynamicContentfulGrid = DynamicContentfulGrid;
}
